import { API } from "../api";

export const memberBankAccountApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMyBankAccount: builder.query({
      query: () => ({
        url: "/members/settings/member_bank?guard=member",
        method: "GET",
      }),
      transformResponse: (responseData) => {
        // Backend returns null when no bank account found (after our fix)
        // Return null so frontend can show "Add Bank Account" button
        return responseData?.data || null;
      },
      providesTags: [{ type: "MemberBankAccount", id: "CURRENT" }],
    }),

    addMyBankAccount: builder.mutation({
      query: (body) => ({
        url: "/members/settings/member_bank/add?guard=member",
        method: "POST",
        body: body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [{ type: "MemberBankAccount", id: "CURRENT" }],
    }),

    validateMyBankAccount: builder.mutation({
      query: ({ account_number, bank_code }) => ({
        url: `/members/settings/verify/${account_number}/${bank_code}?guard=member`,
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
    }),
  }),
});

export const {
  useGetMyBankAccountQuery,
  useAddMyBankAccountMutation,
  useValidateMyBankAccountMutation,
} = memberBankAccountApi;
